<template>
    <div class="pt-24px px-md-16px" v-if="deliveryType == 'regular'">
        <v-card color="primary lighten-4" rounded>
            <div class="px-12px py-16px pa-md-8px">
                <v-row align="center" justify="center" class="row--sm">
                    <v-col cols="12" sm="auto">
                        <div class="txt txt--xs font-weight-medium primary--text text--darken-4">배송주기</div>
                    </v-col>
                    <v-col cols="12" sm="auto">
                        <v-select
                            v-model="deliveryCycle"
                            v-bind="{
                                ...attrs_input,
                                items,
                                style: $vuetify.breakpoint.lgAndUp ? 'width: 500px' : '',
                            }"
                        />
                    </v-col>
                </v-row>
            </div>
        </v-card>
    </div>
</template>

<script>
import { attrs_input } from "@/assets/variables";

const items = [
    { text: "1주일", value: "1week" },
    { text: "2주일", value: "2week" },
    { text: "1달", value: "1month" },
    { text: "3달", value: "3month" },
];

export default {
    props: {
        value: { type: String, default: "1week" },
        deliveryType: { type: String, default: "single" },
    },
    setup: () => ({
        items,
        attrs_input,
    }),
    data: () => ({
        deliveryCycle: "1week",
    }),
    methods: {
        sync() {
            this.deliveryCycle = this.value;
        },
        emit() {
            this.$emit("input", this.deliveryCycle);
        },
    },
    watch: {
        value() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style lang="scss" scoped></style>
